import React from 'react'
import PropTypes from 'prop-types'

import PartnerBox from './PartnerBox'
import PartnerBoxImageOnly from './PartnerBoxImageOnly'

function PartnersTierContainer({ partners, partnersTier }) {
  return (
    <div className="partners-tier-container">
      {
        partnersTier === 'Media'
          ? (
            <span>
              <h3 className="content-subsection__title">{partnersTier} partners</h3>
              <div className="row">
                {partners.map((partner) => {
                  return (
                    <PartnerBoxImageOnly
                      key={partner.slug}
                      partner={partner}
                      imgPath={require(`images/competitions/digital_art/partners/media/${partner.slug}.png`)}
                    />
                  )
                })}
              </div>
            </span>
          )
          : (
            <span>
              <h3 className="content-subsection__title">{partnersTier} tier</h3>
              <div className="row">
                {partners.map((partner) => {
                  return (
                    <PartnerBox
                      key={partner.slug}
                      partner={partner}
                      imgPath={require(`images/competitions/digital_art/partners/${partner.slug}.png`)}
                    />
                  )
                })}
              </div>
            </span>
          )
      }
    </div>
  )
}

PartnersTierContainer.propTypes = {
  partners: PropTypes.array.isRequired,
  partnersTier: PropTypes.string.isRequired,
}

export default PartnersTierContainer
